import produce from "immer";
import { LoadState } from "../../constants/enums";
import { initialMessageSequenceState } from "./defaultState";
import { IMessageSequencesState } from "./MessageSequence.types";
import {
  FETCH_SEQUENCE_LIST_PROGRESS,
  FETCH_SEQUENCE_LIST_SUCCESS,
  FETCH_SEQUENCE_LIST_FAILED,
  FETCH_SEQUENCE_STEPS_PROGRESS,
  FETCH_SEQUENCE_STEPS_SUCCESS,
  FETCH_SEQUENCE_STEPS_FAILED,
  CLEAR_SEQUENCE_STATE,
} from "./MessageSequencesActions";
import { messageSequenceActions } from ".";

export const messageSequenceReducer = (
  state: IMessageSequencesState = initialMessageSequenceState,
  action: messageSequenceActions
): IMessageSequencesState => {
  switch (action.type) {
    case FETCH_SEQUENCE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SEQUENCE_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.data = data;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_SEQUENCE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
      });
      return newState;
    }
    case FETCH_SEQUENCE_STEPS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.steps.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SEQUENCE_STEPS_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.steps.loading = LoadState.Loaded;
        draftState.steps.data = data;
        draftState.steps.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_SEQUENCE_STEPS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.steps.loading = LoadState.Failed;
      });
      return newState;
    }
    case CLEAR_SEQUENCE_STATE: {
      return initialMessageSequenceState;
    }
    default: {
      return state;
    }
  }
};
